import { DocsBlockBuilder } from "../../../../../../tools/docs-block-builder/SDKDocsBlockBuilder";
import { DocsBlockCategory } from "../../../../../enums/SDKDocsBlockCategory";
import { descriptionShort, docsUrl, helpText, id, icon, keywords, name, properties, } from "../do-dont-guidelines/SDKDocsBlockActualDoDontGuidelines";
const b = new DocsBlockBuilder();
/**
 * 3. Block variants
 */
const defaultVariant = b.variantUsingDefaultLayout({
    id: "simple",
    name: "Simple",
    description: "With a minimalist badge at the top, this design is great for content guidelines.",
    image: "https://cdn-assets.supernova.io/blocks/variants/guidelines-simple.svg",
    properties: [properties.type, properties.image, properties.description],
    defaultColumns: 2,
    maxColumns: 3,
});
/**
 * 4. Block item
 */
const blockItem = b.singleVariantItem({
    properties: [properties.image, properties.type, properties.description],
    variant: defaultVariant,
});
/**
 * 5. Block definition
 */
const block = b.multiItemBlock({
    id,
    name,
    icon,
    description: descriptionShort,
    item: blockItem,
    searchKeywords: keywords,
    options: {
        newItemLabel: "Add guideline",
    },
    category: DocsBlockCategory.guidelines,
    onboarding: b.onboarding({
        helpText,
        documentationLink: docsUrl,
    }),
});
/**
 * 6. Block export
 */
export { block as DoDontGuidelines };
